export default class AuthCredentials {
    constructor(public readonly userName: string,
                public readonly token: string) {}

    static fromRaw(json): AuthCredentials {
        return <AuthCredentials>JSON.parse(json);
    }
}
